import {BaseModel} from "./base-model";

export class BaseLocalStorageModel extends BaseModel {
  date: Date;

  constructor(model) {
    super();

    this.date = model?.date ? new Date(model.date) : null;
  }
}
